<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="dialog"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
      >Risultati</v-toolbar>
      <v-card-text>
        <div class="text-h2 pa-12">Hai ottenuto {{ this.esatte }} su 15!</div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="close"
        >chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'Results',
    data: () => ({
    }),
    methods: {
      close() {
        this.$emit('close')
      }
    },
    props: {
      dialog: Boolean,
      esatte: Number
    }
  }
</script>
